module.exports = __webpack_public_path__ + "static/media/26UNRWA1.a6601ef0.jpg";